import * as React from 'react';
import styled from "@emotion/styled";
import { space, width, fontSize, color } from 'styled-system';
import { omit } from 'lodash';

import theme from '../utils/theme';

export const display = ('display');
export const order = ('order');
const wrap = ('flexWrap', 'wrap', 'wrap');
const direction = ('flexDirection', 'direction');
const align = ('alignItems', 'align');
const justify = ('justifyContent', 'justify');
const maxWidth = ('maxWidth');
const position = ('position');
const textAlign = ('textAlign');
const column = props => (props.column ? 'flex-direction:column;' : null);


const defaultExcludedProps = [
  'display',
  'textAlign',
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
  'ba',
  'bb',
  'bt',
  'br',
  'bl',
  'borderRadius',
  'boxShadow',
  'width',
  'maxWidth',
  'fontSize',
  'color',
  'bg',
  'flex',
  'flexAuto',
  'flexCenter',
  'flexGrow',
  'flexShrink',
  'flexBasis',
  'order',
  'wrap',
  'column',
  'direction',
  'align',
  'justify',
  'position',
];

const withPropCleaner = (tag, omitProps) => {
  const displayName = typeof tag === 'string' ? tag : tag.displayName || tag.name || 'Component';
  const PropCleaner = props =>
    React.createElement(tag, omit(props, defaultExcludedProps.concat(omitProps)));
  PropCleaner.displayName = `PropCleaner(${displayName})`;
  return PropCleaner;
};

export default (tag , omitProps) =>
  styled(withPropCleaner(tag, omitProps))(
    space,
    width,
    color,
    order,
    wrap,
    column,
    direction,
    align,
    justify,
    position,
    p => (p.ba ? { border: `1px solid ${theme.colors.border}` } : {}),
    p => (p.bt ? { borderTop: `1px solid ${theme.colors.border}` } : {}),
    p => (p.bb ? { borderBottom: `1px solid ${theme.colors.border}` } : {}),
    p => (p.br ? { borderRight: `1px solid ${theme.colors.border}` } : {}),
    p => (p.bl ? { borderLeft: `1px solid ${theme.colors.border}` } : {}),
    p => (p.borderRadius ? { borderRadius: `4px` } : {}),
    p => (p.flex ? { display: 'flex' } : {}),
    p => (p.flexAuto ? { flex: '1 1 auto' } : {}),
    p =>
      p.boxShadow && typeof p.boxShadow === 'boolean'
        ? { boxShadow: `${theme.boxShadows.default}` }
        : {},
    p => (p.boxShadow && typeof p.boxShadow === 'string' ? { boxShadow: `${p.boxShadow}` } : {}),
    p =>
      p.flexCenter
        ? {
            display: 'flex',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          }
        : {},
    p => (typeof p.flexGrow !== undefined ? { flexGrow: p.flexGrow } : {}),
    p => (typeof p.flexShrink !== undefined ? { flexShrink: p.flexShrink } : {}),
    p => (typeof p.flexBasis !== undefined ? { flexBasis: p.flexBasis } : {}),
  );
